import { rpx } from '@/utils'
import './prop.scss'
import { Tooltip } from 'react-tooltip'
import { randomCode } from '@base/lang'
import { useMemo } from 'react'

interface PropProps {
  name: string
  imgSrc: string
  count: number
  get: boolean
  desc: string
  pkey?: string
}
export default function Prop(props: PropProps) {
  const { name, imgSrc, count, get, desc, pkey } = Object.assign(
    { pkey: '' },
    props
  )
  const countStyle: React.CSSProperties = {
    display: get ? 'none' : 'block',
  }
  const getStyle: React.CSSProperties = {
    display: get ? 'block' : 'none',
  }

  const keyName = useMemo(() => `prop-${count}-${randomCode(10)}`, [count])

  return (
    <div data-key={pkey} className="prop-box">
      <div className={`prop ${keyName}`}>
        <img src={imgSrc} alt=" " />
        <div className="border"></div>
        <i style={countStyle}>{count}</i>
        <div className="prop-get" style={getStyle}></div>
      </div>
      <Tooltip
        anchorSelect={`.${keyName}`}
        place="top"
        style={{
          zIndex: '4',
          padding: rpx(10),
          maxWidth: rpx(384),
          background: 'rgba(0, 0, 0, 0.8)',
        }}
        positionStrategy="fixed"
        openEvents={{ click: true }}
      >
        <div className="prop-name">{name}</div>
        {desc ? <div className="prop-desc">{desc}</div> : null}
      </Tooltip>
    </div>
  )
}
